import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import { UiService } from "app/helper-components/UiService";
import { Constants, Contribution } from "app/helpers/Constants";
import { HelperService } from "app/helpers/helper.service";
import { PostService } from "app/helpers/post.service";
import { UserDataService } from "app/helpers/user-data.service";
import { EventModel } from "app/main/events/event.model";
import { environment } from "environments/environment";
import moment from "moment";
import { ContributionListService } from "../finance/contribution/list/contribution-list.service";
import { ExpenseListService } from "../finance/expense/list/expense-list.service";
import { ImageSliderComponent } from "../image-slider/image-slider.component";
export interface Expense {
  amount: number;
  create_time: string;
  expense_description: string;
  expense_entered_userId: string;
  expense_files: string;
  expense_title: string;
  expense_type: number;
  expense_type_name: string;
  id: number;
  receiptNum: string;
  updated_time: string;
}

@Component({
  selector: "app-singlevent",
  templateUrl: "./singlevent.component.html",
  styleUrls: ["./singlevent.component.scss"],
})
export class SingleventComponent implements OnInit {
  contributions: Contribution[] = [];
  dataSource = new MatTableDataSource(this.contributions);

  expenses: Expense[] = [];
  dataSource1 = new MatTableDataSource(this.expenses);

  displayedColumns = [
    "contribution_id",
    "contributor",
    "date",
    "amount",
    "receiptNum",
    "internal_contirbution",
    "paid",
    "edit",
    "more",
  ];

  displayedColumns1 = [
    "expense_id",
    "expense_title",
    "date",
    "amount",
    "receiptNum",
    "action",
    "edit",
  ];

  @ViewChild(MatSort) sort: MatSort;

  @ViewChild("filter", { static: true })
  filter: ElementRef;
  parameters: any;
  eventId: any;
  singleEvent: any;
  approveBtnStatus = -1;
  editBtnStatus = 1;
  API_FILES = environment.API_FILES;
  dialogRef: any;
  eventDate = "";

  constructor(
    private _activatedRoute: ActivatedRoute,
    private helper: HelperService,
    private postService: PostService,
    private userDataService: UserDataService,
    private _matDialog: MatDialog,
    private contributionListService: ContributionListService,
    private uiService: UiService,
    private expenseListService: ExpenseListService
  ) {}

  ngOnInit(): void {
    this._activatedRoute.queryParams.subscribe((data) => {
      this.parameters = this.helper.getParameters(data["_v"]);
      this.eventId = this.parameters.event_id;
    });

    const formData = new FormData();

    formData.append("getEventById", "1");
    formData.append("event_id", this.eventId);

    this.postService.post(environment.API_EVENT, formData).subscribe((val) => {
      this.singleEvent = val.data;
      this.loadContribution();
      this.loadExpense();
    });
  }

  loadContribution() {
    this.contributionListService
      .getContributions(this.singleEvent)
      .subscribe((val) => {
        const contributions: Contribution[] = val.contributions;
        this.dataSource = new MatTableDataSource(contributions);
        this.dataSource.sort = this.sort;
        this.uiService.hideLoading();
      });
  }

  loadExpense() {
    this.expenseListService.getExpenses(this.singleEvent).subscribe((val) => {
      this.eventDate = val.event_date;
      const expenses: Expense[] = val.expenses;
      this.dataSource1 = new MatTableDataSource(expenses);
      this.dataSource1.sort = this.sort;
      this.uiService.hideLoading();
    });
  }

  zoomImage(file: any) {
    var images = file.event_files.map((val) => {
      return (
        this.API_FILES + "?dir=eventFiles/" + file.event_id + "&name=" + val
      );
    });

    this.dialogRef = this._matDialog.open(ImageSliderComponent, {
      panelClass: "event-form-dialog",
      data: images,
    });
    this.dialogRef.afterClosed();
  }

  enableBtn(action: string, event: EventModel) {
    var isCurrentMonthEvent =
      this.userDataService.serverTime.clone().format("MM/YYYY") ==
      moment(event.data.event_date, "YYYY-MM-DD").format("MM/YYYY");

    switch (action) {
      case "approve":
        return (
          event.data.event_deleted == 0 &&
          event.data.status == -1 &&
          this.approveBtnStatus == 2 &&
          !isCurrentMonthEvent
        );
      case "reject":
        return (
          event.data.event_deleted == 0 &&
          event.data.status == -1 &&
          this.approveBtnStatus == 2 &&
          !isCurrentMonthEvent
        );
      case "question":
        return (
          event.data.event_deleted == 0 &&
          event.data.status == -1 &&
          this.approveBtnStatus == 2 &&
          !isCurrentMonthEvent
        );
      case "edit":
      case "delete":
        if (event.data.status != -1) {
          return false;
        }

        if (this.editBtnStatus == -1) {
          //-1 for remove
          let event_date = moment(event.data.event_date, "YYYY-MM-DD");

          let previous_month = this.userDataService.serverTime
            .clone()
            .subtract(1, "M")
            .endOf("month");
          if (event_date <= previous_month) {
            return false;
          }
        }
        return event.data.event_deleted == 0 && event.data.status == -1;

      case "restore":
        return event.data.event_deleted == 1;
      case "expense_btn":
        return (
          event.data.event_deleted == 0 &&
          !(event.data.options & Constants.EVENT_HIDE_EXPENSES)
        );
      case "contribution_btn":
        return (
          event.data.event_deleted == 0 &&
          !(event.data.options & Constants.EVENT_HIDE_CONTRIBUTION)
        );
      case "spearhead":
        return !(event.data.options & Constants.EVENT_HIDE_SPEAR_HEAD);
      case "fieldworkers":
        return !(event.data.options & Constants.EVENT_HIDE_FIELD_WORKERS);
      case "supporter":
        return event.data.options & Constants.EVENT_SHOW_SUPPORTER;
      case "opponent":
        return event.data.options & Constants.EVENT_SHOW_OPPONENT;
      case "responsibilities":
        return !(event.data.options & Constants.EVENT_HIDE_RESPONSIBILITIES);
      case "uploads":
        return !(event.data.options & Constants.EVENT_HIDE_UPLOADS);
      case "details":
        return !(event.data.options & Constants.EVENT_HIDE_DETAILS);
      case "participants":
        return !(event.data.options & Constants.EVENT_HIDE_PARTICIPANTS);
      default:
        return false;
    }
  }

  isImage(file: string) {
    var isValidFileExtension = [".jpg", ".jpeg", ".gif", ".bmp", ".png"];
    var status = false;
    isValidFileExtension.forEach((val) => {
      if (file.toLowerCase().endsWith(val)) {
        status = true;
      }
    });

    return status;
  }
}
